import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { Link } from 'components/Link/Link';

export const H2 = styled.h2`
  font-weight: 600;
  font-size: 28px;
  line-height: 175%;
  color: ${Colors.black};
`;

export const H3 = styled.h3`
  font-weight: 800;
  font-size: 16px;
  line-height: 175%;
  color: ${Colors.grey900};

  ${mediaQueries.tablet} {
    font-size: 19px;
  }
`;

export const H4 = styled.h4`
  font-weight: 600;
  font-size: 16px;
  line-height: 175%;
  color: ${Colors.grey900};

  ${mediaQueries.tablet} {
    font-size: 19px;
  }
`;

export const P = styled.p`
  font-weight: normal;
  font-size: 16px;
  line-height: 175%;
  color: ${Colors.grey700};
  ${mediaQueries.tablet} {
    font-size: 19px;
  }
`;

export const LI = styled.li`
  display: list-item;
`;
export const OL = styled.ol`
  list-style: decimal;
  margin-left: 10px;
  padding-left: 10px;
`;
export const UL = styled.ul`
  list-style: disc;
  margin-left: 10px;
  padding-left: 10px;
`;
export const QUOTE = styled.blockquote`
  font-style: italic;
  padding-left: 25px;
`;

export const A = styled(Link)`
  color: ${Colors.blue500};
`;

export const BOLD = styled.strong``;
export const CODE = styled.code``;
export const ITALIC = styled.i``;
export const UNDERLINE = styled.u``;
